import {
  AnswerDto,
  QuestionDto,
} from 'libs/features/shared/src/lib/dtos/question.dto';

type CalculateDefaultValues = (
  questions: Array<QuestionDto>,
) => Record<QuestionDto['guid'], AnswerDto['value']>;

export const calculateDefaultValues: CalculateDefaultValues = (questions) =>
  questions.reduce(
    (acc, question) => ({
      ...acc,
      [question.guid]: question.answer.value,
    }),
    {},
  );
